<template>
  <v-container fluid class="rounded-sm">
    <v-row>
      <v-col cols="12" class="pa-0" :class="isSticky ? '' : 'px-3'">
        <WidgetLevelBox
          v-if="type == 'level'"
          :isSticky="isSticky"
          :site="site"
          :level="getCustomer.level"
          :levelColor="getCustomer.level_color"
          :point="getCustomer.point"
          :history_point="getCustomer.history_point"
          :nextLevelName="getCustomer.next_level_name"
          :nextLevelEarn="getCustomer.next_level_earn"
          :nextLevelPointType="getCustomer.next_level_point_type"
        />
        <WidgetGreetingBox
          v-if="type == 'greeting'"
          :isSticky="isSticky"
          :site="site"
          :fullname="getFullName"
          :image="getCustomer.image"
        />
      </v-col>
    </v-row>

    <v-row
      v-if="isSticky && is_use_main_page_search"
      class="d-flex justify-center mt-0"
      data-aos="zoom-in"
    >
      <v-col cols="12">
        <v-card class="mt-n3" color="transparent" rounded="xl">
          <v-card-text class="pa-0">
            <v-container>
              <v-row justify="center">
                <v-col
                  cols="12"
                  sm="6"
                  md="10"
                  class="pa-0"
                  @click="$router.push({ name: 'search' })"
                >
                  <v-text-field
                    hide-details
                    background-color="white"
                    outlined
                    dense
                    class="my-input"
                    prepend-inner-icon="mdi-magnify"
                    :label="$t('searchMissionOrReward')"
                    style="border-radius: 20px"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import WidgetLevelBox from "@/components/widget/level-box.vue";
import WidgetGreetingBox from "@/components/widget/greeting-box.vue";

export default {
  props: ["isSticky"],
  components: {
    WidgetLevelBox,
    WidgetGreetingBox,
  },
  data() {
    return {
      url: "",
      ranking: "",
      type: "level",
      is_use_main_page_search: true,
    };
  },

  mounted() {
    if (this.customer) {
      this.url = this.customer.image;
      this.ranking = this.customer.level;
    }
    this.type = this.site?.display_setting?.home_header || "level";
    this.is_use_main_page_search = [null, undefined].includes(
      this.site?.display_setting?.is_use_main_page_search
    )
      ? true
      : this.site?.display_setting?.is_use_main_page_search;
  },

  methods: {},

  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
    getCustomer() {
      return { ...this.$store.getters["defaultSystem/getCustomer"] };
    },
    defaultImage() {
      return require("@/assets/images/user.svg");
    },
    getFullName() {
      const _customer = { ...this.$store.getters["defaultSystem/getCustomer"] };
      let fullname = `${_customer.name} ${_customer.surname}`.trim();
      return fullname;
    },
  },
  filters: {
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>

<style scoped>
.my-input.v-input .v-input__slot {
  border-radius: 100px;
}
</style>
